import { Appointment, KiloClass } from 'types';

export const NO_COACH_RESOURCE_ID = 'no-coach';

export type TimeFrame = 'past' | 'present' | 'future';

export interface CalendarTileData {
  id: string;
  start: Date;
  totalAppointments: number;
  totalClasses: number;
}
export const getTotalEvents = (
  classes: KiloClass[],
  appointments: Appointment[],
): [CalendarTileData[], number] => {
  const dateToTotalEvents: Record<string, CalendarTileData> = {};
  let maxTotalEvents = 0;
  for (let i = 0; i < classes.length; i += 1) {
    const { startDate, kiloClassId } = classes[i];
    if (dateToTotalEvents[startDate]) {
      dateToTotalEvents[startDate].totalClasses += 1;
    } else {
      const start = new Date(`${startDate}T00:00`);
      dateToTotalEvents[startDate] = {
        start,
        totalClasses: 1,
        totalAppointments: 0,
        id: kiloClassId,
      };
    }
    const totalEvents =
      dateToTotalEvents[startDate].totalAppointments + dateToTotalEvents[startDate].totalClasses;
    if (totalEvents > maxTotalEvents) {
      maxTotalEvents = totalEvents;
    }
  }
  for (let i = 0; i < appointments.length; i += 1) {
    const { startDate, appointmentId } = appointments[i];
    if (dateToTotalEvents[startDate]) {
      dateToTotalEvents[startDate].totalAppointments += 1;
    } else {
      const start = new Date(`${startDate}T00:00`);
      dateToTotalEvents[startDate] = {
        start,
        totalClasses: 0,
        totalAppointments: 1,
        id: appointmentId,
      };
    }
    const totalEvents =
      dateToTotalEvents[startDate].totalAppointments + dateToTotalEvents[startDate].totalClasses;
    if (totalEvents > maxTotalEvents) {
      maxTotalEvents = totalEvents;
    }
  }
  return [Object.values(dateToTotalEvents), maxTotalEvents];
};

export const withNoCoachResource = <R extends { id: string; name: string }>(
  resources: R[],
  events: { resource?: unknown }[],
): (R | { id: string; name: string })[] =>
  events.some(event => event.resource === NO_COACH_RESOURCE_ID)
    ? [{ id: NO_COACH_RESOURCE_ID, name: 'No Coach' }, ...resources]
    : resources;

/** Coach columns for a session, or No Coach when none of its coaches has a column (removed or not marked
 * as coach). */
export const getEventResourceIds = (coachIds: string[], visibleResourceIds: Set<string>): string[] => {
  const coachIdsInView = coachIds.filter(id => visibleResourceIds.has(id));
  return coachIdsInView.length ? coachIdsInView : [NO_COACH_RESOURCE_ID];
};

export const isNoCoachMove = (fromResource: unknown, toResource: unknown): boolean =>
  fromResource !== toResource &&
  (fromResource === NO_COACH_RESOURCE_ID || toResource === NO_COACH_RESOURCE_ID);

export default getTotalEvents;
